import { mdiFacebook, mdiInstagram, mdiWhatsapp } from "@mdi/js";
import Icon from "@mdi/react";

export default function Footer() {
    return (
        <>
            <section className="ftco-section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-6 text-center ">
                            <h2 className="text-business">VRL Sistemas & Tecnologias</h2>
                        </div>
                    </div>
                </div>
            </section>

            <footer className="footer-07">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12 text-center">
                            <p className="d-flex flex-row justify-content-center gap-4 mb-5">
                                <a href="#services">Atuação</a>
                                <a href="#tecnologias">Tecnologias</a>
                                <a href="#processo">Processo</a>
                                <a href="#diferenciais">Diferenciais</a>
                                <a href="#contact">Contato</a>
                            </p>

                            <ul
                                className="d-flex flex-row justify-content-center  gap-4 social-media"
                                style={{ listStyleType: "none" }}
                            >
                                <li className="ftco-animate">
                                    <a
                                        href="#"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title=""
                                        data-original-title="Twitter"
                                    >
                                        <Icon path={mdiInstagram} size={2} />
                                    </a>
                                </li>

                                <li className="ftco-animate">
                                    <a
                                        href="#"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title=""
                                        data-original-title="Twitter"
                                    >
                                        <Icon path={mdiFacebook} size={2} />
                                    </a>
                                </li>

                                <li className="ftco-animate">
                                    <a
                                        href="#"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title=""
                                        data-original-title="Twitter"
                                    >
                                        <Icon path={mdiWhatsapp} size={2} />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="row my-5">
                        <div className="col-md-12 text-center">
                            <p className="copyright">
                                Copyright ©<script>document.write(new Date().getFullYear());</script>2025 Todos os
                                direitos reservados.
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}
